import { render, staticRenderFns } from "./a-product-room-designer.vue?vue&type=template&id=35453aa4&scoped=true&"
import script from "./a-product-room-designer.vue?vue&type=script&lang=js&"
export * from "./a-product-room-designer.vue?vue&type=script&lang=js&"
import style0 from "./a-product-room-designer.vue?vue&type=style&index=0&id=35453aa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35453aa4",
  null
  
)

export default component.exports